import axios from 'axios';
import 'vue-i18n';

let util = {};

util.tap = (function () {
    let _onStart, _onMove, _onEnd, _onCancel, _startPosX, _startPosY, _counter1, _counter2, _isTap,
        _supportTouch = !!(('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);

    _onStart = function (e, active = '') {
        let point = e.changedTouches ? e.changedTouches[0] : e;

        _startPosX = point.pageX;
        _startPosY = point.pageY;
        _isTap = true;

        //避免触摸滑动时过早加上active样式
        _counter1 = setTimeout(() => {
            util.addClass(this, active);
        }, 30);

        //模拟长按
        _counter2 = setTimeout(() => {
            //不是一个tap事件
            _isTap = false;
            util.removeClass(this, active);
        }, 500);
    };

    _onMove = function (e, active) {
        let point = e.changedTouches ? e.changedTouches[0] : e,
            _currPosX = point.pageX,
            _currPosY = point.pageY;

        if (_currPosX - _startPosX > 10 || _currPosY - _startPosY > 10) {
            _counter1 && clearTimeout(_counter1);
            _counter2 && clearTimeout(_counter2);
            _isTap = false;
            util.removeClass(this, active);
        }
    };

    _onEnd = function (e, active) {
        let evt;

        _counter2 && clearTimeout(_counter2);
        setTimeout(() => {
            util.removeClass(this, active);
        }, 100);
        if (_isTap) {
            //evt = new UIEvent('tap', {bubbles: true, cancelable: true})
            evt = document.createEvent('UIEvent');
            evt.initEvent('tap', true, true);
            this.dispatchEvent(evt);
            _isTap = false;
        }
    };

    _onCancel = function (e, active) {
        _counter1 && clearTimeout(_counter1);
        _counter2 && clearTimeout(_counter2);
        _isTap = false;
        util.removeClass(this, active);
    };

    if (_supportTouch) {
        return function (pelm, elm, fn, active) {
            if (typeof elm === 'function') {
                active = fn;
                fn = elm;
                elm = pelm;
                pelm = false;
            }
            util.on('touchstart', pelm, elm, function (e) {
                _onStart.call(this, e, active);
            });
            util.on('touchmove', pelm, elm, function (e) {
                _onMove.call(this, e, active);
            });
            util.on('touchend', pelm, elm, function (e) {
                //prevent ghost click
                e.preventDefault();
                _onEnd.call(this, e, active);
            });
            util.on('touchcancel', pelm, elm, function (e) {
                _onCancel.call(this, e, active);
            });
            util.on('tap', pelm, elm, function (e) {
                if (typeof fn === 'function') {
                    fn.call(this, e);
                }
            });
            //fix bug in meizu mx5 oppo R9 android 5.1 browser
            util.on('touchstart', document, function() {});
        }
    } else {
        return function (pelm, elm, fn, active) {
            if (typeof elm === 'function') {
                active = fn;
                fn = elm;
                elm = pelm;
                pelm = false;
            }
            util.on('click', pelm, elm, function (e) {
                util.addClass(this, active);
                setTimeout(function () {
                    util.removeClass(this, active);
                }, 100);
                fn.call(this, e);
            });
        }
    }
})();

util.addClass = function (elm, kls) {
    if (kls && !util.hasClass(elm, kls)) {
        elm.className += ' ' + kls;
    }
};

util.removeClass = function (elm, kls) {
    let reg;

    if (kls && util.hasClass(elm, kls)) {
        reg = new RegExp(kls.trim(), 'g');
        elm.className = elm.className.replace(reg, '');
    }
};

util.hasClass = function (elm, kls) {
    let isMatch = false,
        classes;

    if (elm && elm.nodeType === Node.ELEMENT_NODE && kls) {
        classes = elm.className.split(' ');
        for (let i = 0; i < classes.length; i++) {
            if (classes[i] === kls) {
                isMatch = true;
                break;
            }
        }
        if (isMatch) return true
    }
    return false
};

util.remove = function (elm) {
    if (elm && elm.nodeType === Node.ELEMENT_NODE) {
        elm.parentNode && elm.parentNode.removeChild(elm);
    }
};

util.on = function (evt, ancestor, elm, fn) {
    if (typeof elm === 'function') {
        fn = elm;
        elm = ancestor;
        ancestor = false;
    }
    if (ancestor) {
        if (typeof ancestor === 'string') {
            ancestor = document.querySelectorAll(ancestor);
        } else {
            ancestor = [].concat(ancestor);
        }
        if (typeof elm === 'string') {
            elm = document.querySelectorAll(elm);
        } else {
            elm = [].concat(elm);
        }
        ancestor.forEach((ant, idx) => {
            ant.addEventListener(evt, function (e) {
                console.log(e.target);
                for (let i = elm.length - 1; i >= 0; i--) {
                    let parent = e.target.parentNode, el = elm[i];

                    if (e.target === el) {
                        //此处event的currentTarget尚有问题，并且无preventDefault
                        fn && fn.call(el, e);
                        continue
                    }
                    while (parent && parent !== ant) {
                        if (parent === el) {
                            //此处event的currentTarget尚有问题，并且无preventDefault
                            fn && fn.call(el, e);
                            break
                        }
                        parent = parent.parentNode;
                    }
                }
            }, false);
        });
    } else {
        if (typeof elm === 'string') {
            elm = document.querySelectorAll(elm);
        } else {
            elm = [].concat(elm);
        }
        elm.forEach((el, idx) => {
            el.addEventListener(evt, function (e) {
                fn && fn.call(this, e);
            }, false);
        });
    }
};

//所有动效接口都需要实现show和hide方法

let Animations;
let NoneAnimation = {
  show: false,
  hide: false
};

//pop动效
let PopAnimation = {
  //参数cb为动效完成后的回调
  show(cb) {
    util.addClass(this.wrap, 'didi-dialog-pop-show');
    this.wrap.addEventListener('webkitAnimationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-pop-show');
      if(typeof cb === 'function') cb();
    });
    this.wrap.addEventListener('animationEnd', () => {
      util.removeClass(this.wrap, 'didi-dialog-pop-show');
      if(typeof cb === 'function') cb();
    });
  },
  hide(cb) {
    util.addClass(this.wrap, 'didi-dialog-pop-hide');
    this.wrap.addEventListener('webkitAnimationEnd', () => {
      util.remove(this.container);
      if(typeof cb === 'function') cb();
    });
    this.wrap.addEventListener('animationEnd', () => {
      util.remove(this.container);
      if(typeof cb === 'function') cb();
    });
  }
};

// slide动效，for tips
let SlideAnimation = {
  show: function(cb) {
    //
    setTimeout(() => {
      util.addClass(this.content, 'didi-dialog-slide-show');
    }, 20);
    setTimeout(() => {
      util.removeClass(this.content, 'didi-dialog-slide-show');
      this.wrap.addEventListener('webkitTransitionEnd', () => {
        util.remove(this.container);
        if(typeof cb === 'function') cb();
      });
    }, this.cfg.timeout || 2000);
  },
  hide: function(cb) {
    //do nothing
  }
};

Animations = {
  none: NoneAnimation,
  pop: PopAnimation,
  slide: SlideAnimation
};

var Animations$1 = Animations;

// import {resolveQuery} from '../../tool'

let obj = {}, // resolveQuery(location.href),
    lang$1 = (obj.lang || 'pt-BR').toLowerCase();


var translation = {
    'pt-br': {
        'confirm': 'Confirmar',
        'cancel': 'Cancelar',
        'gotit': 'Entendi'
    },
    'en-us': {
        'confirm': 'confirm',
        'cancel': 'cancel',
        'gotit': 'Got it'
    },
    'zh-cn': {
        'confirm': '确认',
        'cancel': '取消',
        'gotit': '我知道了'
    }
};

function t(key) {
    if(translation[lang$1]) {
        return translation[lang$1][key] || key
    }

    return key
}

let Components = {}, dd = {};

class Dialog {
    constructor(cfg) {
        let container = document.createElement('div'),
            wall = '<div id="d-wall" class="didi-dialog-wall"></div>',
            wrap =
                '<div id="d-wrap" class="didi-dialog-wrap">' +
                '<div id="d-content" class="didi-dialog-content">' +
                '</div>' +
                '</div>';

        container.setAttribute('id', 'd-container');
        container.setAttribute('class', 'didi-dialog-container');
        container.innerHTML = wall + wrap;

        this.cfg = cfg;
        this.container = container;
        this.wall = container.querySelector('#d-wall');
        this.wrap = container.querySelector('#d-wrap');
        this.content = container.querySelector('#d-content');
        this.addParts();
    }

    addParts() {
        //可以为dialog增加一个特殊标志属性，以便根据该属性来控制样式
        if (this.cfg.tag) {
            this.container.setAttribute(this.cfg.tag, '');
        }
        if (this.cfg.icon !== false) {
            this.addIcon();
        }
        if (this.cfg.title) {
            this.addTitle();
        }
        if (this.cfg.desc) {
            this.addDesc();
        }
        if (this.cfg.btns !== false) {
            this.addButts();
        }
    }

    addIcon() {
        let icon = '<div class="didi-dialog-icon">', img;

        if (this.cfg.icon === false) {
            return false
        } else if (typeof this.cfg.icon === 'string' && this.cfg.icon.match(/^https?:/)) {
            //url方式
            img = '<img src="' + this.cfg.icon + '"/>';
            icon += img;
        } else if (typeof this.cfg.icon === 'string') {
            //标签方式
            icon += this.cfg.icon;
        } else ;
        icon += '</div>';
        this.content.innerHTML += icon;
    }

    addTitle() {
        let title = '<div class="didi-dialog-title">';

        if (!this.cfg.title) {
            return false
        } else if (typeof this.cfg.title === 'string') {
            title += this.cfg.title;
        }
        title += '</div>';
        this.content.innerHTML += title;
    }

    addDesc() {
        let desc = '<div class="didi-dialog-desc">';

        if (!this.cfg.desc) {
            return false
        } else if (typeof this.cfg.desc === 'string') {
            desc += this.cfg.desc;
        }
        desc += '</div>';
        this.content.innerHTML += desc;
    }

    addButts() {
        let btns = this.cfg.btns, butts;

        if (Array.isArray(btns) && btns.length > 0) {
            butts = document.createElement('div');
            butts.setAttribute('class', 'didi-dialog-butts');
            btns.forEach(function (btn, idx) {
                let butt = document.createElement('div');
                btn.id && butt.setAttribute('id', btn.id);
                btn.kls && butt.setAttribute('class', btn.kls);
                butt.innerHTML = btn.text || '';
                butts.appendChild(butt);
                if (typeof btn.callback === 'function') {
                    util.tap(butt, function (e) {
                        //this指向butt
                        btn.callback.call(this, e);
                    }, 'active');
                }
            });
            this.content.appendChild(butts);
        }
    }

    show(animate, cb) {
        document.body.appendChild(this.container);

        if (animate && typeof animate.show === 'function') {
            animate.show.call(this, cb);
        }
    }

    hide(animate, cb) {
        if (animate && typeof animate.hide === 'function') {
            animate.hide.call(this, cb);
        } else {
            setTimeout(() => {
                util.remove(this.container);
            }, 100);
        }
    }
}

//每个组件单独实现，更好单独控制
//alert
Components.alert = function (opt = {}) {
    let cfg, alertObj, animate;

    cfg = {
        desc: opt.desc,
        title: opt.title,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout,
        btns: opt.btns || [{
            id: 'd-btn-ok',
            kls: 'didi-dialog-btn-ok',
            text: opt.text || t('gotit'),
            callback: function (e) {
                e.stopPropagation();
                e.preventDefault();
                alertObj.hide(animate);
                //Fusion.closePage();
                typeof opt.callback === 'function' && opt.callback.call(this, e);
            }
        }]
    };

    alertObj = new Dialog(cfg);
    animate = Animations$1[alertObj.cfg.animateType];
    alertObj.container.setAttribute('dialog-type', 'alert');
    alertObj.show(animate);

    //自动关闭
    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            alertObj.hide(animate);
        }, cfg.timeout);
    }

    return alertObj
};

//confirm
Components.confirm = function (opt = {}) {
    let cfg, confirmObj, animate;

    cfg = {
        title: opt.title,
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon === undefined ? true : opt.icon,
        timeout: opt.timeout,
        btns: opt.btns || [{
            id: 'd-btn-ok',
            kls: 'didi-dialog-btn-ok',
            text: opt.confirmText || t('confirm'),
            callback: function (e) {
                e.stopPropagation();
                e.preventDefault();
                confirmObj.hide(animate);
                typeof opt.confirmCallback === 'function' && opt.confirmCallback.call(this, e);
            }
        },{
            id: 'd-btn-cancel',
            kls: 'didi-dialog-btn-cancel',
            text: opt.cancelText || t('cancel'),
            callback: function (e) {
                e.stopPropagation();
                e.preventDefault();
                confirmObj.hide(animate);
                typeof opt.cancelCallback === 'function' && opt.cancelCallback.call(this, e);
            }
        } ]
    };

    confirmObj = new Dialog(cfg);
    animate = Animations$1[confirmObj.cfg.animateType];
    confirmObj.container.setAttribute('dialog-type', 'confirm');
    confirmObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            confirmObj.hide(animate);
        }, cfg.timeout);
    }
    
    return confirmObj
};

//loading
Components.loading = function (opt = {}) {
    let cfg, loadingObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    loadingObj = new Dialog(cfg);
    animate = Animations$1[loadingObj.cfg.animateType];
    loadingObj.container.setAttribute('dialog-type', 'loading');
    loadingObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            //loading完之后如果需要可回调
            if (typeof cfg.after === 'function') {
                loadingObj.hide(animate, cfg.after);
            } else {
                loadingObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return loadingObj
};

//success
Components.success = function (opt = {}) {
    let cfg, succObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    succObj = new Dialog(cfg);
    animate = Animations$1[succObj.cfg.animateType];
    succObj.container.setAttribute('dialog-type', 'success');
    succObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            if (typeof cfg.after === 'function') {
                succObj.hide(animate, cfg.after);
            } else {
                succObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return succObj
};

//warn
Components.warn = function (opt = {}) {
    let cfg, warnObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'pop',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    warnObj = new Dialog(cfg);
    animate = Animations$1[warnObj.cfg.animateType];
    warnObj.container.setAttribute('dialog-type', 'warn');
    warnObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            if (typeof cfg.after === 'function') {
                warnObj.hide(animate, cfg.after);
            } else {
                warnObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return warnObj
};

Components.tips = function (opt = {}) {
    let cfg, tipsObj, animate;

    cfg = {
        desc: opt.desc,
        animateType: opt.animateType || 'slide',
        tag: opt.tag,
        icon: opt.icon,
        timeout: opt.timeout || 2000,
        after: opt.after
    };

    tipsObj = new Dialog(cfg);
    animate = Animations$1[tipsObj.cfg.animateType];
    tipsObj.container.setAttribute('dialog-type', 'tips');
    tipsObj.show(animate);

    if (typeof cfg.timeout === 'number') {
        setTimeout(function () {
            if (typeof cfg.after === 'function') {
                tipsObj.hide(animate, cfg.after);
            } else {
                tipsObj.hide(animate);
            }
        }, cfg.timeout);
    }

    return tipsObj
};

let c;
for(let i in Components) {
    dd[i] = function(...params) {
        c && c.hide();
        if(params[0] !== false) {
            c = Components[i].apply(null, arguments);
        }
    };
}
window.dd = dd;

axios.defaults.headers.common['Content-Type'] =
  'application/x-www-form-urlencoded';
axios.defaults.timeout = 60 * 1000;
axios.interceptors.request.use (
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject (error);
  }
);

function post (url, ...configs) {
  //处理域名改造
  // url = checkDomianFn (url);
  return axios.post (url, ...configs).then (res => res.data).then (res => {
    if (res.errno == 0) {
      return res.data;
    } else {
      return Promise.reject (res);
    }
  });
}

// const ends = {

const SOURCE = {
  web: '',
  fleetApp: 'com.app99.fleet',
  fleet: 'com.didiglobal.fleet',
  global: 'com.didiglobal.driver',
  globalIos: 'com.didi.global.driver',
  br_99: 'com.app99.driver',
  global_au: 'com.didiglobal.driver.au',
  minibus_new: 'com.didiglobal.bus',
  minibus_old: 'com.didiglobal.driver.bus',
};
const up = new URLSearchParams(location.search);
const ends = {
  isIOS: /(iPhone|iPad|iPod|iOS)/i.test (navigator.userAgent),
  isAndroid: /(Android)/i.test (navigator.userAgent),
  isPC: up.get ('from') === 'official_site',
};

function getEnd() {
  let up = new URLSearchParams(location.search);
  const bundle_id = up.get('bundle_id') || "";
  const fleet_register_pc = up.get('fleet_register_pc');
  const from_fleetPC = up.get('from_fleetPC');
  const from_fleetAPP = up.get('from_fleetAPP');
  let end = "WebEnd"; // 手机浏览器
  if (bundle_id.indexOf(SOURCE.fleetApp) > -1) {
    end = "FleetAppEnd"; // Fleet APP 巴西
  } else if (bundle_id.indexOf(SOURCE.fleet) > -1 && (fleet_register_pc == 1 || from_fleetPC == 1)) {
    end = "FleetPCEnd"; // Fleet PC
  } else if (bundle_id.indexOf(SOURCE.fleet) > -1 && from_fleetAPP == 1) {
    end = "FleetEnd"; // Fleet APP 墨西哥
  } else if (bundle_id.indexOf(SOURCE.global) > -1) {
    end = "DriverEnd"; // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.br_99) > -1) {
    end = "DriverEnd"; // 手机司机端
  } else if (bundle_id.indexOf(SOURCE.globalIos) > -1) {
    end = 'DriverEnd'; // 手机司机端(ios)
  } else if (bundle_id.indexOf(SOURCE.minibus_new) > -1 || bundle_id.indexOf(SOURCE.minibus_old) > -1) {
    end = 'DriverEnd'; // 小巴司机端
  } else if ((ends.isIOS && (up.get('datatype') == 101)) ||
    (ends.isAndroid && (up.get('datatype') == 1))) {
    //乘客端
    end = "PassengerEnd";
  } else if (ends.isPC) {
    //官方网站
    end = "PCEnd";
  }
  return end
}

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 前端h5页面用
var _info = {};

function i18nInit(info) {
  _info = info;
}

function i18nGet(langText, langType) {
  try {
    if (/^ar/.test((langType || "").toLowerCase())) {
      window.i18nArabicRTL = true;
      document.body.setAttribute("class", "".concat((document.body.getAttribute("class") || "").replace(/i18n-Arabic-rtl/g, ''), " i18n-Arabic-rtl").replace(/(^\s+|\s+$)/g, ''));
    }

    if (!window.i18nPluginH5DiffCopywriter || !langType) {
      return langText;
    }

    var langDiff = window.i18nPluginH5DiffCopywriter[langType.toLowerCase().replace("-", "_")];
    if (!langDiff) return langText;
    Object.keys(langDiff).forEach(function (key) {
      if (_info.prefix && new RegExp(_info.prefix).test(key)) {
        langDiff[key.replace(_info.prefix, "")] = langDiff[key];
        delete langDiff[key];
      }
    });

    var walk = function walk(obj, keyStr, value) {
      var keyArr = _info.noParse ? [keyStr] : keyStr.split(".");

      if (keyArr.length === 1) {
        Object.assign(obj, _defineProperty({}, keyStr, value === "[]" ? [] : value));
      } else {
        if (!obj[keyArr[0]]) obj[keyArr[0]] = {};
        Object.assign(obj[keyArr[0]], walk(obj[keyArr[0]], keyArr.slice(1).join("."), value));
      }

      return obj;
    };

    Object.keys(langDiff).map(function (keyStr) {
      walk(langText, keyStr, langDiff[keyStr]);
    });
  } catch (e) {
    console.log('i18n-plugin-error:', e);
  }

  return langText;
}
var i18nInit_1 = i18nInit;
var i18nGet_1 = i18nGet;

var i18nInfo = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "moduleName": "H5-global-fe-Growth-driver-page",
  "filePath": "/packages/headimg-audit/src/locales",
  "version": 515,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-global-fe-Growth-driver-page/packages/headimg-audit/src/locales/all.js",
  "noParse": false,
  "noOmega": false
};

var GDriver_optimization_zvhB_cjIq$6 = "Submit";
var GDriver_optimization_tDnq_eESD$6 = "Unable to recognize your face. Please try again";
var GDriver_optimization_BUsm_LKQr$6 = "Optimizing";
var GDriver_optimization_EjyT_xpZO$6 = "Photo recognition";
var GDriver_optimization_UHSS_rMoK$6 = "Recognition Failed";
var GDriver_optimization_SVLQ_jiyW$6 = "Optimization Completed";
var GDriver_optimization_OekV_nGpZ$6 = "Next";
var GDriver_optimization_eUOa_wjcw$6 = "Photo color vibrancy";
var GDriver_optimization_vEiW_Qiqr$6 = "Look directly at the camera and ensure your entire face is visible";
var GDriver_picture_Line_box_OsdL$6 = "Ensure your entire face is inside the dotted line";
var GDriver_optimization_UAgg_aeEM$6 = "Image cropping";
var GDriver_optimization_LYku_iJnP$6 = "Possibility of approval";
var GDriver_optimization_NtzF_ctdc$6 = "Background Adjustment";
var GDriver_optimization_BBFP_lTCB$6 = "Reupload";
var GDriver_optimization_BDHr_UnLn$6 = "Use this photo?";
var GDriver_picture_View_frame_usSJ$6 = "To ensure fast approval, please use two fingers to move the photo to make sure your entire face is pictured";
var GDriver_optimization_qhaw_wHWp$6 = "Back";
var GDriver_optimization_cXei_rJTN$6 = "System error. Please try again";
var GDriver_optimization_myDn_DSEM$6 = "For faster approval, please make sure the photo is of you. Once confirmed, tap Next, and we’ll help you optimize your profile photo";
var enUS = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$6,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$6,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$6,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$6,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$6,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$6,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$6,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$6,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$6,
	"register---图片尺寸过大": "Your upload must be less than 8MB, please try again.",
	"register---提交": "Next",
	"register---取消": "Cancel",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$6,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$6,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$6,
	"document-expired---返回": "Back",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$6,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$6,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$6,
	"register---确认": "OK",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$6,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$6,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$6,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$6
};

var GDriver_optimization_zvhB_cjIq$5 = "Enviar";
var GDriver_optimization_tDnq_eESD$5 = "Não foi possível reconhecer seu rosto. Por favor, tente novamente";
var GDriver_optimization_BUsm_LKQr$5 = "Otimizando";
var GDriver_optimization_EjyT_xpZO$5 = "Reconhecer foto";
var GDriver_optimization_UHSS_rMoK$5 = "Erro no reconhecimento";
var GDriver_optimization_SVLQ_jiyW$5 = "Otimização concluída";
var GDriver_optimization_OekV_nGpZ$5 = "Avançar";
var GDriver_optimization_eUOa_wjcw$5 = "Cor da foto";
var GDriver_optimization_vEiW_Qiqr$5 = "Olhe diretamente para a câmera e enquadre todo seu rosto";
var GDriver_picture_Line_box_OsdL$5 = "Certifique-se que todo o seu rosto esteja dentro da linha pontilhada";
var GDriver_optimization_UAgg_aeEM$5 = "Cortar a imagem";
var GDriver_optimization_LYku_iJnP$5 = "Possibilidade de aprovação";
var GDriver_optimization_NtzF_ctdc$5 = "Ajustar o fundo";
var GDriver_optimization_BBFP_lTCB$5 = "Reenviar";
var GDriver_optimization_BDHr_UnLn$5 = "Usar esta foto?";
var GDriver_picture_View_frame_usSJ$5 = "Para uma aprovação rápida, use dois dedos para mover a foto e garantir que todo o seu rosto seja enquadrado";
var GDriver_optimization_qhaw_wHWp$5 = "Voltar";
var GDriver_optimization_cXei_rJTN$5 = "Erro no sistema. Tente novamente";
var GDriver_optimization_myDn_DSEM$5 = "Para uma aprovação mais rápida, certifique-se de que a foto é sua. Após a confirmação, toque em Avançar e ajudaremos você a otimizar a foto de perfil";
var ptBR = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$5,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$5,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$5,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$5,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$5,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$5,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$5,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$5,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$5,
	"register---图片尺寸过大": "O tamanho da imagem é muito grande, por favor envie novamente",
	"register---提交": "Avançar",
	"register---取消": "Corrigir",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$5,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$5,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$5,
	"document-expired---返回": "Retorno",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$5,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$5,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$5,
	"register---确认": "Avançar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$5,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$5,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$5,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$5
};

var GDriver_optimization_zvhB_cjIq$4 = "Enviar";
var GDriver_optimization_tDnq_eESD$4 = "No se logró reconocer tu cara. Por favor, inténtalo de nuevo.";
var GDriver_optimization_BUsm_LKQr$4 = "Optimizando";
var GDriver_optimization_EjyT_xpZO$4 = "Reconocimiento de la foto";
var GDriver_optimization_UHSS_rMoK$4 = "Error de reconocimiento";
var GDriver_optimization_SVLQ_jiyW$4 = "Optimización completada";
var GDriver_optimization_OekV_nGpZ$4 = "Siguiente";
var GDriver_optimization_eUOa_wjcw$4 = "Brillo de la foto";
var GDriver_optimization_vEiW_Qiqr$4 = "Mira a la cámara de frente para que se vea tu cara completa";
var GDriver_picture_Line_box_OsdL$4 = "Asegúrate de que toda tu cara esté dentro de la línea de puntos";
var GDriver_optimization_UAgg_aeEM$4 = "Recorte de la imagen";
var GDriver_optimization_LYku_iJnP$4 = "Posibilidad de aprobación";
var GDriver_optimization_NtzF_ctdc$4 = "Ajuste de fondo";
var GDriver_optimization_BBFP_lTCB$4 = "Reintentar";
var GDriver_optimization_BDHr_UnLn$4 = "¿Quieres usar esta foto?";
var GDriver_picture_View_frame_usSJ$4 = "Para agilizar la aprobación, usa dos dedos para mover la foto y asegurarte de que se vea toda tu cara.";
var GDriver_optimization_qhaw_wHWp$4 = "Volver";
var GDriver_optimization_cXei_rJTN$4 = "Error. Por favor, reinténtalo.";
var GDriver_optimization_myDn_DSEM$4 = "Para agilizar la aprobación, asegúrate de que la foto sea tuya. Luego, toca en “Siguiente” y te ayudaremos a optimizar tu foto de perfil.";
var esMX = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$4,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$4,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$4,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$4,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$4,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$4,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$4,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$4,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$4,
	"register---图片尺寸过大": "El tamaño de la imagen es muy grande, que no se pude subir",
	"register---提交": "Finalizar",
	"register---取消": "Cancelar",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$4,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$4,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$4,
	"document-expired---返回": "Volver",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$4,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$4,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$4,
	"register---确认": "Enviar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$4,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$4,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$4,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$4
};

var GDriver_optimization_zvhB_cjIq$3 = "Enviar";
var GDriver_optimization_tDnq_eESD$3 = "No se logró reconocer tu cara. Por favor, inténtalo de nuevo.";
var GDriver_optimization_BUsm_LKQr$3 = "Optimizando";
var GDriver_optimization_EjyT_xpZO$3 = "Reconocimiento de la foto";
var GDriver_optimization_UHSS_rMoK$3 = "Error de reconocimiento";
var GDriver_optimization_SVLQ_jiyW$3 = "Optimización completada";
var GDriver_optimization_OekV_nGpZ$3 = "Siguiente";
var GDriver_optimization_eUOa_wjcw$3 = "Brillo de la foto";
var GDriver_optimization_vEiW_Qiqr$3 = "Mira a la cámara de frente para que se vea tu cara completa";
var GDriver_picture_Line_box_OsdL$3 = "Asegúrate de que toda tu cara esté dentro de la línea de puntos";
var GDriver_optimization_UAgg_aeEM$3 = "Recorte de la imagen";
var GDriver_optimization_LYku_iJnP$3 = "Posibilidad de aprobación";
var GDriver_optimization_NtzF_ctdc$3 = "Ajuste de fondo";
var GDriver_optimization_BBFP_lTCB$3 = "Reintentar";
var GDriver_optimization_BDHr_UnLn$3 = "¿Quieres usar esta foto?";
var GDriver_picture_View_frame_usSJ$3 = "Para agilizar la aprobación, usa dos dedos para mover la foto y asegurarte de que se vea toda tu cara.";
var GDriver_optimization_qhaw_wHWp$3 = "Atrás";
var GDriver_optimization_cXei_rJTN$3 = "Error. Por favor, reinténtalo.";
var GDriver_optimization_myDn_DSEM$3 = "Para agilizar la aprobación, asegúrate de que la foto sea tuya. Luego, toca en “Siguiente” y te ayudaremos a optimizar tu foto de perfil.";
var esCO = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$3,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$3,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$3,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$3,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$3,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$3,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$3,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$3,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$3,
	"register---图片尺寸过大": "El tamaño de la imagen es muy grande, que no se pude subir",
	"register---提交": "Finalizar",
	"register---取消": "Cancelar",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$3,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$3,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$3,
	"document-expired---返回": "Volver",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$3,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$3,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$3,
	"register---确认": "Aceptar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$3,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$3,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$3,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$3
};

var GDriver_optimization_zvhB_cjIq$2 = "Enviar";
var GDriver_optimization_tDnq_eESD$2 = "No se logró reconocer tu cara. Por favor, inténtalo de nuevo.";
var GDriver_optimization_BUsm_LKQr$2 = "Optimizando";
var GDriver_optimization_EjyT_xpZO$2 = "Reconocimiento de la foto";
var GDriver_optimization_UHSS_rMoK$2 = "Error de reconocimiento";
var GDriver_optimization_SVLQ_jiyW$2 = "Optimización completada";
var GDriver_optimization_OekV_nGpZ$2 = "Siguiente";
var GDriver_optimization_eUOa_wjcw$2 = "Brillo de la foto";
var GDriver_optimization_vEiW_Qiqr$2 = "Mira a la cámara de frente para que se vea tu cara completa";
var GDriver_picture_Line_box_OsdL$2 = "Asegúrate de que toda tu cara esté dentro de la línea de puntos";
var GDriver_optimization_UAgg_aeEM$2 = "Recorte de la imagen";
var GDriver_optimization_LYku_iJnP$2 = "Posibilidad de aprobación";
var GDriver_optimization_NtzF_ctdc$2 = "Ajuste de fondo";
var GDriver_optimization_BBFP_lTCB$2 = "Reintentar";
var GDriver_optimization_BDHr_UnLn$2 = "¿Quieres usar esta foto?";
var GDriver_picture_View_frame_usSJ$2 = "Para agilizar la aprobación, usa dos dedos para mover la foto y asegurarte de que se vea toda tu cara.";
var GDriver_optimization_qhaw_wHWp$2 = "Volver";
var GDriver_optimization_cXei_rJTN$2 = "Error. Por favor, reinténtalo.";
var GDriver_optimization_myDn_DSEM$2 = "Para agilizar la aprobación, asegúrate de que la foto sea tuya. Luego, toca en “Siguiente” y te ayudaremos a optimizar tu foto de perfil.";
var es419 = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$2,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$2,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$2,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$2,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$2,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$2,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$2,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$2,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$2,
	"register---图片尺寸过大": "El tamaño de la imagen es muy grande, que no se pude subir",
	"register---提交": "Finalizar",
	"register---取消": "Cancelar",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$2,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$2,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$2,
	"document-expired---返回": "Volver",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$2,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$2,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$2,
	"register---确认": "Aceptar",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$2,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$2,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$2,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$2
};

var GDriver_optimization_zvhB_cjIq$1 = "Submit";
var GDriver_optimization_tDnq_eESD$1 = "Unable to recognise your face. Please try again";
var GDriver_optimization_BUsm_LKQr$1 = "Optimising...";
var GDriver_optimization_EjyT_xpZO$1 = "Photo Recognition";
var GDriver_optimization_UHSS_rMoK$1 = "Recognition Failed";
var GDriver_optimization_SVLQ_jiyW$1 = "Optimisation Completed";
var GDriver_optimization_OekV_nGpZ$1 = "Next";
var GDriver_optimization_eUOa_wjcw$1 = "Background colour vibrancy";
var GDriver_optimization_vEiW_Qiqr$1 = "Look directly at the camera and ensure your full face is visible";
var GDriver_picture_Line_box_OsdL$1 = "Ensure your entire face is inside the dotted line";
var GDriver_optimization_UAgg_aeEM$1 = "Image Cropping";
var GDriver_optimization_LYku_iJnP$1 = "Possibility of approval";
var GDriver_optimization_NtzF_ctdc$1 = "Background Adjustment";
var GDriver_optimization_BBFP_lTCB$1 = "Upload Again";
var GDriver_optimization_BDHr_UnLn$1 = "Do you want to use this photo?";
var GDriver_picture_View_frame_usSJ$1 = "To ensure fast approval, please use two fingers to move the photo to make sure your entire face is pictured";
var GDriver_optimization_qhaw_wHWp$1 = "Back";
var GDriver_optimization_cXei_rJTN$1 = "System error. Please try again";
var GDriver_optimization_myDn_DSEM$1 = "For faster approval, please make sure the photo is of you. Once confirmed, tap Next, and we’ll help you optimise your profile photo";
var esAU = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq$1,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD$1,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr$1,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO$1,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK$1,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW$1,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ$1,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw$1,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr$1,
	"register---图片尺寸过大": "Your upload must be less than 8MB, please try again.",
	"register---提交": "Next",
	"register---取消": "Cancel",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL$1,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM$1,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP$1,
	"document-expired---返回": "Back",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc$1,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB$1,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn$1,
	"register---确认": "OK",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ$1,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp$1,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN$1,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM$1
};

var GDriver_optimization_zvhB_cjIq = "إرسال";
var GDriver_optimization_tDnq_eESD = "تعذّر التعرُّف على وجهك. يُرجى المحاولة مرة أخرى";
var GDriver_optimization_BUsm_LKQr = "جارٍ التحسين";
var GDriver_optimization_EjyT_xpZO = "التعرُّف على الصورة";
var GDriver_optimization_UHSS_rMoK = "تعذّر التعرُّف";
var GDriver_optimization_SVLQ_jiyW = "اكتمل التحسين";
var GDriver_optimization_OekV_nGpZ = "التالي";
var GDriver_optimization_eUOa_wjcw = "سطوع ألوان الصورة";
var GDriver_optimization_vEiW_Qiqr = "انظر إلى الكاميرا مباشرةً وتأكد من ظهور وجهك بالكامل";
var GDriver_picture_Line_box_OsdL = "تأكد من أن وجهك بالكامل داخل الخط المنقط";
var GDriver_optimization_UAgg_aeEM = "قص الصورة";
var GDriver_optimization_LYku_iJnP = "احتمالية الموافقة";
var GDriver_optimization_NtzF_ctdc = "تعديل الخلفية";
var GDriver_optimization_BBFP_lTCB = "إعادة تحميل";
var GDriver_optimization_BDHr_UnLn = "هل تريد استخدام هذه الصورة؟";
var GDriver_picture_View_frame_usSJ = "لضمان سرعة الموافقة، يُرجى استخدام أصبعين لتحريك الصورة والتأكد من أن وجهك ظاهر بالكامل";
var GDriver_optimization_qhaw_wHWp = "رجوع";
var GDriver_optimization_cXei_rJTN = "خطأ في النظام، أعِد المحاولة";
var GDriver_optimization_myDn_DSEM = "للحصول على الموافقة بسرعة أكبر، يُرجى التأكد من أن الصورة هي صورتك. بمجرد التأكد، اضغط على \"التالي\"، وسنُساعدك على تحسين صورتك التعريفية.";
var arEG = {
	GDriver_optimization_zvhB_cjIq: GDriver_optimization_zvhB_cjIq,
	GDriver_optimization_tDnq_eESD: GDriver_optimization_tDnq_eESD,
	GDriver_optimization_BUsm_LKQr: GDriver_optimization_BUsm_LKQr,
	GDriver_optimization_EjyT_xpZO: GDriver_optimization_EjyT_xpZO,
	GDriver_optimization_UHSS_rMoK: GDriver_optimization_UHSS_rMoK,
	GDriver_optimization_SVLQ_jiyW: GDriver_optimization_SVLQ_jiyW,
	GDriver_optimization_OekV_nGpZ: GDriver_optimization_OekV_nGpZ,
	GDriver_optimization_eUOa_wjcw: GDriver_optimization_eUOa_wjcw,
	GDriver_optimization_vEiW_Qiqr: GDriver_optimization_vEiW_Qiqr,
	"register---图片尺寸过大": "يجب أن لا يتجاوز حجم التحميل 8 ميجابايت. أعِد المحاولة.",
	"register---提交": "التالي",
	"register---取消": "إلغاء",
	GDriver_picture_Line_box_OsdL: GDriver_picture_Line_box_OsdL,
	GDriver_optimization_UAgg_aeEM: GDriver_optimization_UAgg_aeEM,
	GDriver_optimization_LYku_iJnP: GDriver_optimization_LYku_iJnP,
	"document-expired---返回": "رجوع",
	GDriver_optimization_NtzF_ctdc: GDriver_optimization_NtzF_ctdc,
	GDriver_optimization_BBFP_lTCB: GDriver_optimization_BBFP_lTCB,
	GDriver_optimization_BDHr_UnLn: GDriver_optimization_BDHr_UnLn,
	"register---确认": "موافق",
	GDriver_picture_View_frame_usSJ: GDriver_picture_View_frame_usSJ,
	GDriver_optimization_qhaw_wHWp: GDriver_optimization_qhaw_wHWp,
	GDriver_optimization_cXei_rJTN: GDriver_optimization_cXei_rJTN,
	GDriver_optimization_myDn_DSEM: GDriver_optimization_myDn_DSEM
};

i18nInit_1 (i18nInfo);

let lang = new URLSearchParams (location.search).get ('lang');
const i18n = {
  locale: lang || 'en-US',
  fallbackLocale:'default',
  messages: {
    'pt-BR': i18nGet_1 (ptBR, 'pt-br'),
    'es-MX': i18nGet_1 (esMX, 'es-mx'),
    'es-CO': i18nGet_1 (esCO, 'es-co'),
    'en-AU': i18nGet_1 (esAU, 'en-au'),
    'es-419': i18nGet_1 (es419, 'es-419'),
    'ar-EG': arEG,
    default: i18nGet_1 (enUS, lang),
  },
};

var ErrorDialog = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"error-dialog"},[_c('div',{staticClass:"bg-mask"}),_vm._v(" "),_c('div',{staticClass:"error-dialog-foot"},[_c('div',{staticClass:"close-foot-title"},[_vm._v("\n      "+_vm._s(_vm.$t("GDriver_optimization_UHSS_rMoK"))+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"close-foot-text"},[_c('div',{staticClass:"close-foot-content"},[_vm._v(_vm._s(_vm.errorText))])]),_vm._v(" "),_c('div',{staticClass:"close-foot-btn"},[_c('div',{class:['foot-btn', 'confirm', ("confirm-" + _vm.location_country)],on:{"click":_vm.goBack}},[_vm._v("\n        "+_vm._s(_vm.$t("GDriver_optimization_BBFP_lTCB"))+"\n      ")])])])]):_vm._e()},
staticRenderFns: [],
  i18n: i18n,
  props: ["routerParams", "errorText", "visible"],
  computed: {
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    omegaItems() {
      return {
        end: getEnd(),
        channel: this.params.get("channel") || "",
        oid: this.params.get("oid") || Omega.getOmgid(),
        location_cityid: this.params.get("location_cityid") || "",
        location_country: this.params.get("location_country") || "",
        profile_channel: this.routerParams.page_source === "personal-info" ? 1 : 0,
        uid: this.routerParams.onboarding_driver_id || this.driver_id,
        product: this.routerParams.product,
      }
    }
  },
  data() {
    return {
      driver_id: "",
    };
  },
  mounted() {
    Fusion &&
      Fusion.getUserInfo &&
      Fusion.getUserInfo({}, (res) => {
        this.driver_id = res.uid;
      });
  },
  methods: {
    close() {},
    goBack() {
      try {
        Omega.trackEvent("ibt_global_portrait_uploadfailure_retake_button_ck", "", {
          ...this.omegaItems
        });
      } catch (error) { }
      this.$router.replace({
        name: "avatarNew",
        params: {
          ...this.routerParams,
          isGoBack: true,
        },
      });
    },
  },
};

var progressnew = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-progress",class:[
    'el-progress--' + _vm.type,
    _vm.status ? 'is-' + _vm.status : '',
    {
      'el-progress--without-text': !_vm.showText,
      'el-progress--text-inside': _vm.textInside,
    }
  ],attrs:{"role":"progressbar","aria-valuenow":_vm.percentage,"aria-valuemin":"0","aria-valuemax":"100"}},[(_vm.type === 'line')?_c('div',{staticClass:"el-progress-bar"},[_c('div',{staticClass:"el-progress-bar__outer",style:({height: _vm.strokeWidth + 'px', backgroundColor:_vm.defineBackColor})},[_c('div',{staticClass:"el-progress-bar__inner",style:(_vm.barStyle)},[(_vm.showText && _vm.textInside)?_c('div',{staticClass:"el-progress-bar__innerText",style:({color:_vm.textColor})},[_vm._v(_vm._s(_vm.content))]):_vm._e()])])]):_c('div',{staticClass:"el-progress-circle",style:({height: _vm.width + 'px', width: _vm.width + 'px'})},[_c('svg',{attrs:{"viewBox":"0 0 100 100"}},[_c('path',{staticClass:"el-progress-circle__track",style:(_vm.trailPathStyle),attrs:{"d":_vm.trackPath,"stroke":_vm.defineBackColor,"stroke-width":_vm.relativeStrokeWidth,"fill":"none"}}),_vm._v(" "),_c('path',{staticClass:"el-progress-circle__path",style:(_vm.circlePathStyle),attrs:{"d":_vm.trackPath,"stroke":_vm.stroke,"fill":"none","stroke-linecap":_vm.strokeLinecap,"stroke-width":_vm.percentage ? _vm.relativeStrokeWidth : 0}})])]),_vm._v(" "),(_vm.showText && !_vm.textInside)?_c('div',{staticClass:"el-progress__text",style:({fontSize: _vm.progressTextSize + 'px', color:_vm.textColor})},[(!_vm.status)?[_vm._v(_vm._s(_vm.content))]:_c('i',{class:_vm.iconClass})],2):_vm._e()])},
staticRenderFns: [],
      name: 'ElProgress',
      props: {
        type: {
          type: String,
          default: 'line',
          validator: val => ['line', 'circle', 'dashboard'].indexOf(val) > -1
        },
        percentage: {
          type: Number,
          default: 0,
          required: true,
          validator: val => val >= 0 && val <= 100
        },
        status: {
          type: String,
          validator: val => ['success', 'exception', 'warning'].indexOf(val) > -1
        },
        strokeWidth: {
          type: Number,
          default: 6
        },
        strokeLinecap: {
          type: String,
          default: 'round'
        },
        textInside: {
          type: Boolean,
          default: false
        },
        width: {
          type: Number,
          default: 126
        },
        showText: {
          type: Boolean,
          default: true
        },
        color: {
          type: [String, Array, Function],
          default: ''
        },
        defineBackColor: {
          type: [String, Array, Function],
          default: '#ebeef5'
        },
        textColor: {
          type: [String, Array, Function],
          default: '#606266'
        },
        format: Function
      },
      computed: {
        barStyle() {
          const style = {};
          style.width = this.percentage + '%';
          style.backgroundColor = this.getCurrentColor(this.percentage);
          return style;
        },
        relativeStrokeWidth() {
          return (this.strokeWidth / this.width * 100).toFixed(1);
        },
        radius() {
          if (this.type === 'circle' || this.type === 'dashboard') {
            return parseInt(50 - parseFloat(this.relativeStrokeWidth) / 2, 10);
          } else {
            return 0;
          }
        },
        trackPath() {
          const radius = this.radius;
          const isDashboard = this.type === 'dashboard';
          return `
            M 50 50
            m 0 ${isDashboard ? '' : '-'}${radius}
            a ${radius} ${radius} 0 1 1 0 ${isDashboard ? '-' : ''}${radius * 2}
            a ${radius} ${radius} 0 1 1 0 ${isDashboard ? '' : '-'}${radius * 2}
            `;
        },
        perimeter() {
          return 2 * Math.PI * this.radius;
        },
        rate() {
          return this.type === 'dashboard' ? 0.75 : 1;
        },
        strokeDashoffset() {
          const offset = -1 * this.perimeter * (1 - this.rate) / 2;
          return `${offset}px`;
        },
        trailPathStyle() {
          return {
            strokeDasharray: `${(this.perimeter * this.rate)}px, ${this.perimeter}px`,
            strokeDashoffset: this.strokeDashoffset
          };
        },
        circlePathStyle() {
          return {
            strokeDasharray: `${this.perimeter * this.rate * (this.percentage / 100) }px, ${this.perimeter}px`,
            strokeDashoffset: this.strokeDashoffset,
            transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease'
          };
        },
        stroke() {
          let ret;
          if (this.color) {
            ret = this.getCurrentColor(this.percentage);
          } else {
            switch (this.status) {
              case 'success':
                ret = '#13ce66';
                break;
              case 'exception':
                ret = '#ff4949';
                break;
              case 'warning':
                ret = '#e6a23c';
                break;
              default:
                ret = '#20a0ff';
            }
          }
          return ret;
        },
        iconClass() {
          if (this.status === 'warning') {
            return 'el-icon-warning';
          }
          if (this.type === 'line') {
            return this.status === 'success' ? 'el-icon-circle-check' : 'el-icon-circle-close';
          } else {
            return this.status === 'success' ? 'el-icon-check' : 'el-icon-close';
          }
        },
        progressTextSize() {
          return this.type === 'line'
            ? 12 + this.strokeWidth * 0.4
            : this.width * 0.111111 + 2 ;
        },
        content() {
          if (typeof this.format === 'function') {
            return this.format(this.percentage) || '';
          } else {
            return `${this.percentage}%`;
          }
        }
      },
      methods: {
        getCurrentColor(percentage) {
          if (typeof this.color === 'function') {
            return this.color(percentage);
          } else if (typeof this.color === 'string') {
            return this.color;
          } else {
            return this.getLevelColor(percentage);
          }
        },
        getLevelColor(percentage) {
          const colorArray = this.getColorArray().sort((a, b) => a.percentage - b.percentage);
  
          for (let i = 0; i < colorArray.length; i++) {
            if (colorArray[i].percentage > percentage) {
              return colorArray[i].color;
            }
          }
          return colorArray[colorArray.length - 1].color;
        },
        getColorArray() {
          const color = this.color;
          const span = 100 / color.length;
          return color.map((seriesColor, index) => {
            if (typeof seriesColor === 'string') {
              return {
                color: seriesColor,
                percentage: (index + 1) * span
              };
            }
            return seriesColor;
          });
        }
      }
    };

const Fusion$1 = window.Fusion;
var avatarNewBetter = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head-image-preview"},[(_vm.isTakePhoto && !_vm.goUpload)?[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.uploadImgSrc}})]),_vm._v(" "),_c('div',{staticClass:"desc-wrapper"},[_c('h3',{staticClass:"desc-title"},[_vm._v(_vm._s(_vm.$t("GDriver_optimization_BDHr_UnLn")))]),_vm._v(" "),_c('div',{staticClass:"desc-content"},[_c('p',[_vm._v(_vm._s(_vm.$t("GDriver_optimization_myDn_DSEM")))])])]),_vm._v(" "),_c('div',{staticClass:"btn-action"},[_c('div',{staticClass:"btns cancel-btn",on:{"click":function($event){return _vm.goBack('previewPage')}}},[_vm._v("\n        "+_vm._s(_vm.$t("register---取消"))+"\n      ")]),_vm._v(" "),_c('div',{class:['btns', 'confirm-btn', ("confirm-btn-" + _vm.location_country)],on:{"click":_vm.goNextUpload}},[_vm._v("\n        "+_vm._s(_vm.$t("GDriver_optimization_OekV_nGpZ"))+"\n      ")])])]:[_c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.generated_image || _vm.uploadImgSrc}}),_vm._v(" "),(_vm.optiType !== 'success')?_c('div',{staticClass:"img-mask"}):_vm._e(),_vm._v(" "),(_vm.optiType !== 'success')?_c('progressnew',{staticClass:"upload-progress",attrs:{"type":"circle","percentage":_vm.upgrade_progress,"define-back-color":"transparent","stroke-width":4,"color":_vm.location_country === 'BR' ? '#FFDD00' : '#FF8040'}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"desc-wrapper"},[_c('h3',{staticClass:"desc-title"},[_vm._v("\n        "+_vm._s(_vm.optiType === "success"
            ? _vm.$t("GDriver_optimization_SVLQ_jiyW")
            : _vm.$t("GDriver_optimization_BUsm_LKQr"))+"\n      ")]),_vm._v(" "),(_vm.optiType === 'success')?_c('div',{staticClass:"opti-complete"},[_c('div',{staticClass:"opti-complete-item"},[_c('span',{staticClass:"opti-complete-item-text"},[_vm._v(_vm._s(_vm.$t("GDriver_optimization_eUOa_wjcw")))]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"opti-complete-item"},[_c('span',{staticClass:"opti-complete-item-text"},[_vm._v(_vm._s(_vm.$t("GDriver_optimization_LYku_iJnP")))]),_vm._v(" "),_vm._m(1)])]):_c('div',{staticClass:"desc-content opti-ing"},[_c('p',[_c('span',{staticClass:"opti-text"},[_vm._v(_vm._s(_vm.$t("GDriver_optimization_EjyT_xpZO")))]),_c('span',{class:['opti-icon', _vm.upload_status]})]),_vm._v(" "),_c('p',[_c('span',{staticClass:"opti-text"},[_vm._v(_vm._s(_vm.$t("GDriver_optimization_UAgg_aeEM")))]),_c('span',{class:['opti-icon', _vm.generated_status]})]),_vm._v(" "),_c('p',[_c('span',{staticClass:"opti-text"},[_vm._v(_vm._s(_vm.$t("GDriver_optimization_NtzF_ctdc")))]),_c('span',{class:['opti-icon', _vm.generated_status]})])])]),_vm._v(" "),(_vm.optiType === 'success')?_c('div',{staticClass:"complete-btn-action"},[_c('div',{class:['submit-btn', ("submit-btn-" + _vm.location_country)],on:{"click":_vm.submitImg}},[_vm._v("\n        "+_vm._s(_vm.$t("GDriver_optimization_zvhB_cjIq"))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"cancel-btn",on:{"click":function($event){return _vm.goBack('submitPage')}}},[_vm._v("\n        "+_vm._s(_vm.$t("register---取消"))+"\n      ")])]):_vm._e()],_vm._v(" "),_c('ErrorDialog',{attrs:{"routerParams":_vm.uploadConfig,"errorText":_vm.api_error_msg,"visible":_vm.error_dialog_visible}})],2)},
staticRenderFns: [function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"opti-complete-item-icon"},[_c('img',{attrs:{"src":"https://s3-us01.didiglobal.com/silver-bullet-img/2023-10-16/lSi7i1/icon_up_40_2x.png","alt":""}})])},function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"opti-complete-item-icon"},[_c('img',{attrs:{"src":"https://s3-us01.didiglobal.com/silver-bullet-img/2023-10-16/lSi7i1/icon_up_40_2x.png","alt":""}})])}],
  name: "headImage",
  i18n: i18n,
  components: {
    ErrorDialog,
    progressnew
  },
  // props: [
  //   "uploadImgSrc",
  // ],
  data() {
    return {
      enter_time_zone: "",
      leave_time_zone: "",
      driver_id: "",
      goUpload: false,
      upgrade_progress: 0,
      imgExt: "", // 图片类型: jpeg, png
      optiType: "ing", // 优化中: ing, 优化失败: fail, 优化成功: success
      upload_img_api: "/gulfstream/colossus/image/upload/uploadImg", // 上传图片接口
      gift_key: "", // 原图gift_key
      upload_status: "ing", // 图片上传是否成功状态
      algorithmically_api:
        "/gulfstream/deadpool/register/algorithmicallyGenerate", // 算法优化接口
      generated_gift_key: "", // 算法优化过后生成的图片gift_key
      generated_image: "", // 算法优化过后生成的图片链接
      generated_status: "ing", // 算法优化是否成功
      submit_api: "/gulfstream/deadpool/register/addPostPortrait", // 新的提交头像接口(后置使用)
      register_submit_api: "/gulfstream/deadpool/register/addAuditInfo",
      api_error_msg: "",
      error_dialog_visible: false,
    };
  },
  created() {
    this.enter_time_zone = new Date().getTime();
  },
  mounted() {
    Fusion$1 &&
      Fusion$1.getUserInfo &&
      Fusion$1.getUserInfo({}, (res) => {
        this.driver_id = res.uid;
      });
    if (!this.isTakePhoto && this.uploadImgSrc) {
      this.uploadImg();
    }
    if (this.isTakePhoto) {
      try {
        Omega.trackEvent("ibt_global_portrait_photopreview_sw", "", {
          ...this.omegaItems,
        });
      } catch (error) {}
    }
  },
  beforeDestroy() {
    if (this.goUpload) {
      this.leave_time_zone = new Date().getTime();
      try {
        Omega.trackEvent("ibt_global_portrait_back_button_ck", "", {
          ...this.omegaItems,
          time_zone: this.leave_time_zone - this.enter_time_zone,
          upload_type: this.upload_status,
          algorithm_type: this.generated_status,
        });
      } catch (error) {}
    }
  },
  methods: {
    uploadImg() {
      this.goUpload = true;
      try {
        Omega.trackEvent("ibt_global_portrait_optimization_sw", "", {
          ...this.omegaItems,
        });
      } catch (error) {}
      // 如果上传接口成功，就需要接着调用智能算法接口
      const success = (data) => {
        dd.loading(false);
        this.upload_status = "success";
        this.upgrade_progress = 50;
        this.gift_key = data.img_id;
        this.generatedImg(data.img_id);

        Omega.trackEvent("upload_success", "", {
          duid: this._uuid || new URLSearchParams(location.search).get("uid"),
          app_upload: this.inApp,
          wait_time: new Date() - this.uploadStart,
          origin_size: this.originSize,
          compressed_size: this.compressedSize,
        });
      };

      dd.loading({
        timeout: 15000,
      });
      this.imgExt = this.uploadImgSrc
        .split(";")[0]
        .slice(this.uploadImgSrc.split(";")[0].indexOf("/") + 1);
      let up = new URLSearchParams(location.search);
      up.append("__x_img", this.uploadImgSrc);
      up.append("type", this.auditConfig.key);
      if (this.uploadConfig._ticket) {
        up.set("ticket", this.uploadConfig._ticket);
      }
      // console.log("----", this.uploadConfig);
      // console.log(this.uploadConfig.upload_base_url);
      post(`${this.uploadConfig.upload_base_url}${this.upload_img_api}`, up)
        .then(success)
        .catch((res) => {
          this.upload_status = "fail";
          this.httpError(res, "upload");
        });
    },
    generatedImg(url) {
      const generatedImg = (data) => {
        this.generated_gift_key = data.generated_gift_key;
        this.generated_image = data.generated_image;
        this.upgrade_progress = 100;
        setTimeout(() => {
          this.optiType = "success";
          this.generated_status = "success";
        }, 1000);
        dd.loading(false);
        try {
          Omega.trackEvent("ibt_global_portrait_optimization_sucess_sw", "", {
            ...this.omegaItems,
          });
        } catch (error) {}
      };
      const up = new URLSearchParams(location.search);
      const country_code = up.get("location_country");
      up.append("country_code", country_code);
      up.append("gift_key", url);
      if (this.uploadConfig._ticket) {
        up.set("ticket", this.uploadConfig._ticket);
      }
      post(`${this.uploadConfig.base_url}${this.algorithmically_api}`, up)
        .then(generatedImg)
        .catch((res) => {
          this.generated_status = "fail";
          this.httpError(res, "generated");
        });

      //   const test_data = {
      //     "data": {
      //       "generated_gift_key": "abccc"
      //     }
      //   }
      //   generatedImg(test_data)
    },
    httpError(res, type) {
      try {
        Omega.trackEvent("ibt_profile_recognition_failed_sw", "", {
          ...this.omegaItems,
          error_type: type,
          error_code: res ? res.errno || '' : ''
        });
      } catch (error) {}
      this.optiType = "fail";
      dd.loading(false);
      if (type === "generated") {
        this.api_error_msg =
          res.errmsg || this.$t("GDriver_optimization_cXei_rJTN");
      } else {
        this.api_error_msg = this.$t("GDriver_optimization_cXei_rJTN");
      }
      this.error_dialog_visible = true;
      // dd.alert({
      //   desc: res.errmsg || this.$t("GDriver_optimization_cXei_rJTN")
      // });
    },
    submitImg() {
      dd.loading({
        timeout: 15000,
      });
      try {
        Omega.trackEvent(
          "ibt_global_portrait_optimization_sucess_submit_button_ck",
          "",
          {
            ...this.omegaItems,
          }
        );
      } catch (error) {}
      const up = new URLSearchParams(location.search);
      const country_code = up.get("location_country");
      up.append("country_code", country_code);
      up.append(this.auditConfig.key, JSON.stringify([this.gift_key]));
      up.append(
        this.auditConfig.algorithmically_generated_key,
        JSON.stringify([this.generated_gift_key])
      );
      up.append("ext", this.imgExt);
      if (this.uploadConfig._ticket) {
        up.set("ticket", this.uploadConfig._ticket);
      }

      const _submit_url =
        this.uploadConfig.page_source === "personal-info"
          ? this.submit_api
          : this.register_submit_api;

      post(`${this.uploadConfig.base_url}${_submit_url}`, up)
        .then(() => {
          dd.loading(false);
          if (this.onSubmit && typeof this.onSubmit === "function") {
            this.onSubmit();
          }
        })
        .catch((res) => {
          this.httpError(res, "submit");
        });
    },
    goBack(type) {
      if (type === "previewPage") {
        try {
          Omega.trackEvent(
            "ibt_global_portrait_photopreview_retake_button_ck",
            "",
            {
              ...this.omegaItems,
            }
          );
        } catch (error) {}
      } else if (type === "submitPage") {
        try {
          Omega.trackEvent(
            "ibt_global_portrait_optimization_sucess_retake_button_ck",
            "",
            {
              ...this.omegaItems,
            }
          );
        } catch (error) {}
      }
      this.$router.replace({
        name: "avatarNew",
        params: {
          ...this.uploadConfig,
          isGoBack: true,
        },
      });
    },
    goNextUpload() {
      try {
        Omega.trackEvent(
          "ibt_global_portrait_photopreview_next_button_ck",
          "",
          {
            ...this.omegaItems,
          }
        );
      } catch (error) {}
      this.uploadImg();
    },
  },
  computed: {
    inApp() {
      return Fusion$1 ? !!Fusion$1.chooseImage : false;
    },
    params() {
      return new URLSearchParams(location.search);
    },
    location_country() {
      return this.params.get("location_country");
    },
    uploadConfig() {
      let c = this.$route.params;
      return c || {};
    },
    uploadImgSrc() {
      return this.uploadConfig.uploadImgSrc;
      // return "https://static.didiglobal.com/global/driver/apps/dinfo/driver-info/images/error_sample1@2x.png";
    },
    isTakePhoto() {
      return this.uploadConfig.isTakePhoto;
    },
    // 和证件任务有关的配置
    auditConfig() {
      return this.uploadConfig.configs || {};
    },
    onSubmit() {
      return this.uploadConfig.onSubmit;
    },
    omegaItems() {
      return {
        end: getEnd(),
        channel: this.params.get("channel") || "",
        oid: this.params.get("oid") || Omega.getOmgid(),
        location_cityid: this.params.get("location_cityid") || "",
        location_country: this.params.get("location_country") || "",
        profile_channel:
          this.uploadConfig.page_source === "personal-info" ? 1 : 0,
        uid: this.uploadConfig.onboarding_driver_id || this.driver_id,
        product: this.uploadConfig.product,
      };
    },
  },
};

export { avatarNewBetter };
